import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateCustomAttributeQueries } from '@/modules/common/utils/query-invalidation';

import { deleteCustomAttribute } from '../../api/custom-attributes.api';

/**
 * Deletes a single custom attribute definition and refreshes attribute + team queries.
 */
export const useDeleteCustomAttribute = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (id: number) => deleteCustomAttribute(id),
    onSuccess: async () => {
      await invalidateCustomAttributeQueries(queryClient);
    },
    onError: error =>
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.settings:api.error.customAttributes.deleteFailed'
      ),
  });
};
